export * from './login';
export * from './session';
export * from './user';
export * from './xsrf';
export * from './profile';

import {loginReducer as login} from './login';
import {profileReducer as Profiles} from './profile';
import {profileListReducer as ProfilesList} from './profileslist';
import {sessionReducer as session} from './session';
import {userReducer as user} from './user';
import {websiteReducer as Website} from './website';
import {blogReducer as Blog} from './blog';
import {agencyReducer as Agency} from './agency';
import {searchReducer as Search} from './search';
import {xsrfReducer as xsrf} from './xsrf';
import {adReducer as Ads} from './advertise'



export const reducers = {login,Blog,Profiles,ProfilesList,Agency,session,user,Website,Ads,Search,xsrf};
